module.exports = __webpack_public_path__ + "static/media/search.87b06dce.svg";